import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import { Container, Row, Col } from '../../components/Bootstrap'
import Hero from '../../components/Hero'

import { colours, mq, spacers } from '../../theme'
import { align, bold } from '../../styles'

import logo from '../../images/logo.svg'

const TitleText = styled('h1')`
	text-align: center;
	text-transform: uppercase;
	${mq.medium(css`
		text-align: left;
	`)}
`
const BoldText = styled('p')`
	border-bottom: medium solid ${colours.primary};
	padding-bottom: 0.5rem;
	text-align: center;
	${bold};
	${mq.medium(css`
		text-align: left;
	`)}
`

const TagLine = styled('div')`
	padding: ${spacers['5']};
	${align.center};
	${bold};
	${mq.medium(css`
		text-align: left;
	`)}
`

const Intro = () => (
	<Hero style={{ paddingBottom: 0 }}>
		<Container>
			<Row className={`justify-content-center ${align.left}`}>
				<Col md="3" xs="10" className="mb-4">
					<img src={logo} alt="Center for Independant Living in Toronto" style={{ width: '100%' }} />
				</Col>
				<Col md="5" xs="12">
					<TitleText>CILT Strategic Plan Renewal</TitleText>
					<BoldText>Final Outline: September 6, 2018</BoldText>
					<p>Strategic Plan 2025</p>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md="9">
					<TagLine>
						Contribute to the achievement of social and economic equity in collaboration with people with disabilities through an inclusive approach
					</TagLine>
				</Col>
			</Row>
		</Container>
	</Hero>
)

export default Intro
